import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { AdminUserService, ClaimApi, ApplicationUserApi } from 'src/app/services/admin-user.service';
import { DssValidators } from 'src/app/services/dss.validators';
import { LoadingService } from 'src/app/services/loading.service';
import { LoginService } from 'src/app/services/login.service';

import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-applicationuser',
  templateUrl: './applicationuser.component.html',
  styleUrls: ['./applicationuser.component.scss']
})
export class ApplicationuserComponent implements OnInit {

  @Input() allroles: any[];
  @Input() allapps: any[];
  //@Input() user: ApplicationUserApi;

  dropdownSettingsRoles: IDropdownSettings = {};
  dropdownSettingsApps: IDropdownSettings = {};

  newSelectedRoles: any[];
  oldSelectedRoles: any[];
  curSelectedRoles: any[];
  newSelectedApps: any[];
  oldSelectedApps: any[];
  curSelectedApps: any[];
  resetPassword: boolean;
  pwInputType = "password";
  isIEOrEdge: boolean;

  updateClaimsFailure: string ;
  returnUrl: string;
  user: ApplicationUserApi = null;
  unsubscribe: Subject<any> = new Subject;

  @ViewChild('au', {static: false}) zv: NgbAccordion;

  authenticated: Observable<boolean>;
  userForm: FormGroup = null;
  
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: AdminUserService,
  ) { 

    this.userForm = new FormGroup({
      username: new FormControl(),
      email: new FormControl(),
      password: new FormControl(),
      newPassword: new FormControl('', [
        Validators.minLength(8),
        DssValidators.hasDigit,
        DssValidators.hasLowerCase,
        DssValidators.hasUpperCase,
        DssValidators.hasNonAlphaNumeric
      ]),
      roles: new FormArray([]),
      dssclaims: new FormArray([]),
      submitRegister: new FormControl()
    });
  } 

  ngOnInit() {
    this.isIEOrEdge = /msie\s|trident\/|edg\//i.test(window.navigator.userAgent);

    this.userService.selectedUser
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(selected => {
        if (selected) {
          this.user = selected;
          //console.log('au: selected user: ' + selected.name);
          this.buildFormData();
        }
      });

    this.dropdownSettingsRoles = {
      singleSelection: false,
      idField: 'claimValue',
      textField: 'claimValue',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      maxHeight: 300,
      itemsShowLimit: 3,
      allowSearchFilter: false,
      defaultOpen: true
    };

    this.dropdownSettingsApps = {
      singleSelection: false,
      idField: 'appropriatorId',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      maxHeight: 300,
      itemsShowLimit: 3,
      allowSearchFilter: false,
      defaultOpen: true
    };

  }

  showPasswordToggle() {
    if (this.pwInputType === "password") {
      this.pwInputType = "text";
    } else {
      this.pwInputType = "password";
    }
  }

  buildFormData() {
    this.oldSelectedRoles = [];
    this.newSelectedRoles = [];
    //console.log('au init: time: ' + Date.now().toString());
    //if (!!this.user) {
      for (let r of this.user.roles)
      {
        this.oldSelectedRoles.push(r);
        this.newSelectedRoles.push(r);
      }
      //console.log('au selected roles: ' + JSON.stringify(this.newSelectedRoles));
    //}

    this.oldSelectedApps = [];
    this.newSelectedApps = [];
    if (!!this.user)
    {
      for (let c of this.user.dssClaims)
      {
        this.oldSelectedApps.push(this.getAppropriatorApiObj(c.claimValue));
        this.newSelectedApps.push(this.getAppropriatorApiObj(c.claimValue));
      }
    }

    /*
    this.curSelectedRoles = [];
    this.newSelectedRoles = [];
    if (!!this.allroles)
    {
      this.allroles.forEach((role) => {
        if (this.oldSelectedRoles.indexOf(role) >= 0)
        {
          this.newSelectedRoles.push(role);
        }
        this.curSelectedRoles.push(role);
      });
    }
    */
  }

  updateHasErrors() {
    var rp = this.password();
    if (!!rp.errors && ( 
        rp.errors.minlength ||
        rp.errors.hasDigit ||
        rp.errors.hasLowerCase ||
        rp.errors.hasUpperCase ||
        rp.errors.hasNonAlphaNumeric)) { return true; }
    return false;
  }

  async updateUser() {
    if (!this.user)
    { return; }
    /* Assure we don't set a password if the reset options is not selected */
    if (this.resetPassword == false) {
      this.user.newPassword = null;
    } else {
      if (this.updateHasErrors()) {
        this.user.newPassword = null;
      } else {
        this.user.newPassword = this.password().value;
      }
    }
    let result = await this.userService.updateuser(this.user);
    this.updateClaimsFailure = result.failureMessage;
    //this.registerClicked = false;
    if (!this.updateClaimsFailure) {
      setTimeout(() => {
        //this.modalService.dismissAll();
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/admin';
        this.router.navigateByUrl(this.returnUrl);
      }, 1000);  
    }
    this.userForm.reset();
  }

  password() {
    return this.userForm.get('newPassword');
  }

  getAppropriatorApiObj(claimvalue: any) {
    var arr = claimvalue.split(',');
    if (arr.length == 3)
    {
      return {appropriatorId: +arr[1], name: arr[2]};
    }
  }

  getAppropriatorName(claimvalue: string) : string {
    var arr = claimvalue.split(',');
    if (arr.length == 3)
    {
      return arr[2];
    }
  }

  auToggle() { }

  buildSelectedRolesCollection() {
    this.user.roles = [];
    if (this.newSelectedRoles.length > 0)
    {
      for (var i=0; i< this.newSelectedRoles.length; i++)
      {
        let newRole: ClaimApi = {
          claimType: "DssRole",
          claimValue: this.newSelectedRoles[i].claimValue,
        }
        this.user.roles.push(newRole);
      }
    }
  }
  
  onItemSelectRole(item: any) {
    this.buildSelectedRolesCollection();
  }
  onItemDeSelectRole(item: any) {
    this.buildSelectedRolesCollection();
  }
  onSelectAllRole(items: any) {
    this.newSelectedRoles = [];
    items.forEach((r) => {
      this.newSelectedRoles.push(r);
    });
    this.buildSelectedRolesCollection();
  }

  onDeSelectAllRole(items: any) {
    this.newSelectedRoles = [];
    this.buildSelectedRolesCollection();
  }

  buildSelectedAppsCollection() {
    this.user.dssClaims = [];
    if (this.newSelectedApps.length > 0)
    {
      for (var i=0; i< this.newSelectedApps.length; i++)
      {
        let newApp: ClaimApi = {
          claimType: "AppropriatorId",
          claimValue: this.newSelectedApps[i].appropriatorId + '',
        }
        this.user.dssClaims.push(newApp);
      }
    }
  }
  
  onItemSelectApp(item: any) {
    this.buildSelectedAppsCollection();
  }
  onItemDeSelectApp(item: any) {
    this.buildSelectedAppsCollection();
  }
  onSelectAllApp(items: any) {
    this.newSelectedApps = [];
    items.forEach((a) => {
      this.newSelectedApps.push(a);
    });
    this.buildSelectedAppsCollection();
  }

  onDeSelectAllApp(items: any) {
    this.newSelectedApps = [];
    this.buildSelectedAppsCollection();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  disableUpdateButton() {
    if ((this.password().errors == null && this.resetPassword == true && this.password().value != null) || (this.resetPassword == false || typeof this.resetPassword === 'undefined') ) {
      return false;
    } else {
      return true;
    }
  }

}
